// src/hooks/useDeviceType.js
import { useState, useEffect } from 'react';

export const useDeviceType = () => {
  const [isMobile, setIsMobile] = useState(false); // Default to desktop

  useEffect(() => {
    const checkDevice = () => {
      // Simply check if isMobile is 'true' in localStorage
      const storedIsMobile = localStorage.getItem('isMobile') === 'true';
      setIsMobile(storedIsMobile);
    };

    checkDevice();
    
    // Listen for storage changes (if localStorage is updated from another tab/window)
    window.addEventListener('storage', checkDevice);
    
    return () => window.removeEventListener('storage', checkDevice);
  }, []);

  return { isMobile };
};
